<template>
    <div class="group-parcel-case">
        <div class="label-parcel">
            <span>
                รายละเอียดพัสดุ
            </span>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
                <label class="label-input" for="">
                    <p class="m-0">    
                        <span class="text-danger">*</span><span>น้ำหนักรวม</span>
                    </p>
                </label>
                <div class="input-weight">
                    <input type="text" v-model="parcel.weight" class="form-control" :class="{ 'is-invalid':  errorshow.parcel.sumWeight || parcelValidation.weight.$error }"  placeholder="">
                    <span class="unit">
                        กรัม
                    </span>
                </div>
                <div v-if="errorshow.parcel.sumWeight || parcelValidation.weight.$error">
                    <div v-if="errorshow.parcel.sumWeight" class="">
                        <label class="invalid-feedback">กรุณาใส่น้ำหนักรวมให้ถูกต้อง</label>
                    </div>
                    <div v-else-if="!parcelValidation.weight.required">
                        <label class="invalid-feedback">กรุณากรอกน้ำหนักรวม</label>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-6">
                
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <label class="label-input" for="">
                    <p class="m-0">    
                        <span>ขนาดกล่อง</span>
                    </p>
                </label>
                <AutoBox
                class="m-0"
                @itemPreRate="logginData"
                :nonshowlabel="true"
                :listSize="listSize"
                :size="parcel.size"
                :weight.sync="parcel.weight"
                :weightKG.sync="parcel.weightKG" 
                :width.sync="parcel.width"
                :length.sync="parcel.length" 
                :height.sync="parcel.height" 
                :keyBox.sync="parcel.key_size"
                :favoriteDimension="favoriteDimension"
                courier_key="DEFAULT" />
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <label class="label-input">
                    <p class="m-0">    
                        <span class="text-danger">*</span><span>ขนาดพัสดุ</span>
                    </p>
                </label>
                <div class="form-group m-0">
                    <Dimension
                        :nonshowlabel="true"
                        ref="dimensionParcel"
                        :dimension="parcel"
                        courierCode="DEFAULT"
                        :favoriteDimension="favoriteDimension"
                        @lockDimensionParcel="lockDimensionParcel"
                        :openBorderError="parcelValidation.width.$error || parcelValidation.length.$error || parcelValidation.height.$error ? true : false"
                    />
                </div> 
                <div v-if="parcelValidation.width.$error || parcelValidation.length.$error || parcelValidation.height.$error">
                    <div v-if="!parcelValidation.width.required || !parcelValidation.length.required || !parcelValidation.height.required">
                        <label class="invalid-feedback">กรุณาใส่ขนาด กว้าง x ยาว x สูง</label>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="label-parcel">
            <span>
                รายละเอียดพัสดุภายในกล่อง
            </span>
        </div>
        <div class="group-inside-parcel">
            <div v-for="(item,index) in inputParcel" :key="index" class="row">
                <div class="col-12 col-md-12 col-lg-6">
                    <div class="row">
                        <div class="col-1 align-self-end">
                            <h2>
                                {{ index+1 }}.)
                            </h2>
                        </div>
                        <div class="col-11 align-self-end">
                            <label class="label-input" for="">
                                <p class="m-0">    
                                    <span class="text-danger">*</span><span>ประเภทพัสดุ</span>
                                </p>
                            </label>
                            <v-select 
                                placeholder="กรุณาเลือกประเภทพัสดุ"
                                class="mb-3"
                                :options="category"
                                label="text"
                                v-model="inputParcel[index].type_parcel.text"
                                :class="{ 'is-invalid bd-danger': inputParcelValidation[index].type_parcel.id.$error }" 
                                @input="assigntypeParcel($event, index)"
                            >
                            <template slot="selected-option" slot-scope="option">
                                <span>
                                {{ option.text }}
                                </span>
                            </template>
                            </v-select>
                            <div v-if="inputParcelValidation[index].type_parcel.id.$error">
                                <label
                                    v-if="!inputParcelValidation[index].type_parcel.id.required"
                                    class="invalid-feedback"
                                    >
                                    กรุณาเลือกประเภทของสินค้า
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-2">
                    <label class="label-input">
                        <p class="m-0">
                            <span class="text-danger">*</span><span>น้ำหนักพัสดุ</span>
                        </p>
                    </label>
                    <div class="input-weight">
                        <b-form-input 
                            :class="{ 'is-invalid': inputParcelValidation[index].weight.$error }" 
                            v-model="item.weight"
                        >

                        </b-form-input>
                        <span class="unit">
                            กรัม
                        </span>
                    </div>
                    <div v-if="inputParcelValidation[index].weight.$error">
                        <label
                            v-if="!inputParcelValidation[index].weight.required"
                            class="invalid-feedback"
                            >
                            กรุณากรอกน้ำหนักพัสดุ
                        </label>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-2">
                    <label class="label-input">
                        <p class="m-0">    
                            <span class="text-danger">*</span><span>มูลค่ารวม</span>
                        </p>
                    </label>
                    <div class="input-weight">
                        <input type="text" class="form-control" v-model="item.overall_price" :class="{ 'is-invalid': inputParcelValidation[index].overall_price.$error }" placeholder="">
                        <span class="unit">
                            บาท
                        </span>
                    </div>
                    <div v-if="inputParcelValidation[index].overall_price.$error">
                        <label
                        v-if="!inputParcelValidation[index].overall_price.required"
                        class="invalid-feedback"
                        >กรุณากรอกมูลค่ารวม</label>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-2">
                    <div class="d-flex">
                        <label class="label-input" for="">
                            <p class="m-0">    
                                <span class="text-danger">*</span><span>จำนวน</span>
                            </p>
                        </label>
                    </div>
                    <div class="d-flex">
                        <div class="input-weight w-100">
                            <input type="text" v-model="item.count_parcel" class="form-control" :class="{ 'is-invalid': inputParcelValidation[index].count_parcel.$error }" placeholder="">
                            <span class="unit">
                                ชิ้น
                            </span>
                        </div>
                        <div v-if="countParcelOne" class="trash-parcel cursor-pointer align-self-center ml-3">
                            <i class="fas fa-trash-alt" @click="$emit('removeParcel',index)"></i>
                        </div>
                    </div>
                    <div v-if="inputParcelValidation[index].count_parcel.$error">
                        <label
                        v-if="!inputParcelValidation[index].count_parcel.required"
                        class="invalid-feedback"
                        >กรุณากรอกจำนวนชิ้น
                        </label>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-6">
                    <div class="row">
                        <div class="col align-self-end">
                           
                        </div>
                        <div class="col-12 col-lg-11 align-self-end">
                            <label class="label-input">
                                <p class="m-0">    
                                    <span class="text-danger">*</span><span>ผลิตจากประเทศ</span>
                                </p>
                            </label>
                            <b-form-group id="input-group-1" label-for="input-1">
                                <v-select 
                                    placeholder="กรุณาเลือกประเทศ"
                                    :options="countries" 
                                    label="text"
                                    v-model="inputParcel[index].country_parcel.text"
                                    :class="{ 'is-invalid bd-danger': inputParcelValidation[index].country_parcel.id.$error }" 
                                    @input="assignCountries($event, index)"
                                >
                                <template slot="selected-option" slot-scope="option">
                                    <span>
                                    {{ option.text }}
                                    </span>
                                </template>
                                </v-select>
                            </b-form-group>
                            <div v-if="inputParcelValidation[index].country_parcel.id.$error">
                                <label
                                    v-if="!inputParcelValidation[index].country_parcel.id.required"
                                    class="invalid-feedback"
                                    >กรุณากรอกพัสดุผลิตจากประเทศ
                                </label>
                            </div>
                        </div>
                    </div>     
                </div>
                <div class="col-12 col-md-12 col-lg-6">
                    <div class="d-flex justify-content-between">
                        <label class="label-input" for="">
                            <p class="m-0">    
                                <span>HS Code </span>                    
                            </p>
                        </label>
                        <label class="label-input cursor-pointer hover-underline-text">
                            <p class="m-0">    
                                <span class="text-right" v-b-tooltip.hover title="คือ พิกัดศุลกากร ใช้สำหรับจำแนกประเภทของสินค้า">
                                    <i class="fas fa-exclamation-circle mr-2"></i>
                                    What's HS Code ?
                                </span>
                            </p>
                        </label>
                    </div>
                    <input v-model="item.hscode" type="text" class="form-control" placeholder="000000">
                </div>
            </div>
            <div class="divider mt-4">
                <b-button class="px-5 w-50" variant="outline-primary" @click="$emit('addParcel')">
                    เพิ่มพัสดุ
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import AutoBox from '@/components/AutoBox';
import Dimension from '@/components/custom/pos/Dimension';
import setLocalStorage from '@/constants/LocalStorageManagement'

export default {
    props: {
        editInter: {
            type: [Object, Array]
        },
        parcelValidation: {
            type: [Object, Array]
        },
        inputParcelValidation: [Object, Array],
        inputParcel: [Array, Object],
        listSize: {
            type: [Object, Array]
        },
        shop_id: [String, Number],
        selectedCourier: {
            type: [String, Object]
        },
        countries: {
            type: [Object, Array]
        },
        country: {
            type: [Object, Array]
        },
        errorshow: {
            type: Object
        },
        parcel: {
            type: [Object, Array]
        }
    },
    components: {
        AutoBox,
        Dimension
    },
    data() {
        return {
            category: [
                {
                    value: null,
                    text: '----- กรุณาเลือกประเภทพัสดุ -----'
                }
            ],
            favoriteDimension: false,
        }
    },
    computed: {
        sumWeightValue: {
          get() {
            return this.sum_weight;
          },
          set(newValue) {
            this.$emit('sum_weight', newValue); 
          },
        },
        countParcelOne() {
            return this.inputParcel.length !== 1 ? true : false
        },
        formatCalculate() {
            let count_over = 0
            this.inputParcel.map((res) => {
                count_over = count_over + parseInt(res.weight)
            })
            console.log('count_over: ', count_over)
            return count_over
        }
    },
    methods: {
        assignCountries(event, index) {
            console.log('inputParcel: ', this.inputParcel[index])
            this.inputParcel[index].country_parcel = {}
            this.inputParcel[index].country_parcel.id = event.id
            this.inputParcel[index].country_parcel.text = event.text
            this.inputParcel[index].country_parcel.alpha_2_code = event.alpha_2_code
            this.inputParcel[index].country_parcel.alpha_3_code = event.alpha_3_code
            this.inputParcel[index].country_parcel.calling_code = event.calling_code
            this.inputParcel[index].country_parcel.destination_supported = event.destination_supported
            this.inputParcel[index].country_parcel.manufacturer_supported = event.manufacturer_supported
        },
        assigntypeParcel(event, index) {
            this.inputParcel[index].type_parcel = {}
            this.inputParcel[index].type_parcel.text = event.text
            this.inputParcel[index].type_parcel.id = event.value
            this.inputParcel[index].type_parcel.text_only_en = event.text_only_en
            this.inputParcel[index].type_parcel.text_only_th = event.text_only_th
        },
        logginData() {
            // อนาคตจะเปลี่ยนอะไรก็ ใช้ฟังก์ชั่นนี้ เด้อ
        },
        lockDimensionParcel() {
              let dimension = {
                width: this.parcel.width,
                length: this.parcel.length,
                height: this.parcel.height,
                size: this.parcel.size.boxSize
              }
          
              let keyCourier = this.selectedCourier.key;
          
              let key = `${keyCourier}_${this.shop_id}`
              let setDimension = this.getDimensionLocalStorage()
          
              if (setDimension.status) {
                setLocalStorage.dimension().remove(key);
                this.favoriteDimension = false;
                return false;
              }
          
              if (dimension.width > 0 || dimension.length > 0 || dimension.height > 0) {
                setLocalStorage.dimension().set(key, dimension);
                this.favoriteDimension = true;
              }
        },
        getDimensionLocalStorage() {
          let keyCourier = this.selectedCourier.key;

          let key = `${keyCourier}_${this.shop_id}`;
          let checkDimension = setLocalStorage.dimension().get(key);
          
          return (checkDimension[key])
            ? { status: true, data: checkDimension[key] }
            : { status: false }
        },
        async getAllCategory() {
            this.$emit('busyHandle', true)
            const headers = {
                headers: {
                    token: localStorage.getItem('access_token')
                }
            }
            await this.$http.get(this.$API_URL + '/inter/all/category', headers).then(async (res) => {
                await res.data.data.rows.map((resData) => {
                    const ObjectValue = {
                        value: resData.id,
                        text: resData.title_en + ' (' + resData.title_th + ')',
                        text_only_en: resData.title_en,
                        text_only_th: resData.title_th,
                    }
                    this.category.push(ObjectValue)
                })
            }).finally(() => {
                this.$emit('busyHandle', false)
            })
        },
        setInstanceParcel() {
            const instanceData = this.getDimensionLocalStorage()
            if(!this.editInter.status && instanceData) {
                this.parcel.size.boxSize = instanceData.data && instanceData.data.size ? instanceData.data.size : this.parcel.size.boxSize
                this.parcel.height = instanceData.data && instanceData.data.height ? instanceData.data.height : this.parcel.height
                this.parcel.width = instanceData.data && instanceData.data.width ? instanceData.data.width : this.parcel.width
                this.parcel.length = instanceData.data && instanceData.data.length ?  instanceData.data.length : this.parcel.length
                this.favoriteDimension = instanceData.status
            }
        },
    },
    async mounted() {
        await this.getAllCategory()
        this.setInstanceParcel()
    }
}
</script>
<style lang="scss" scoped>
.invalid-feedback {
    display: block;
}

</style>